import * as React from 'react';
import { SignInPage } from '@toolpad/core/SignInPage';
import { AppProvider } from '@toolpad/core/AppProvider';
import { useTheme } from '@mui/material/styles';

import { useNavigate } from 'react-router-dom';

const providers = [{ id: 'nodemailer', name: 'Email' }];


export default function LoginPage() {
  const theme = useTheme();
  const navigate = useNavigate();

  const allowedDomains = ['msg.com']

  const signIn = async (provider, formData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const email = formData?.get('email') || '';
        const domain = email.split('@')[1];
        if (!allowedDomains.includes(domain)) {
          alert('Email domain not allowed.');
          resolve();
          return;
        }
        console.log(`Sign in with ${provider.id}`);
        localStorage.setItem('redirectAuthEmail', email);
        navigate('/dashboard');
        resolve();
      }, 500);
    });
  };

  return (
    <AppProvider theme={theme}>
      <SignInPage
        signIn={signIn}
        providers={providers}
        slotProps={{ emailField: { autoFocus: false }, form: { noValidate: true } }}
      />
    </AppProvider>
  );
}
